import React from "react";
import {
  alpha,
  Box,
  Collapse,
  IconButton,
  Paper,
  Typography,
  useTheme,
} from "@mui/material";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import CloseIcon from "@mui/icons-material/Close";

interface NarrativeOnlyBannerProps {
  visible: boolean;
  onDismiss: () => void;
}

export const NarrativeOnlyBanner: React.FC<NarrativeOnlyBannerProps> = ({
  visible,
  onDismiss,
}) => {
  const theme = useTheme();

  return (
    <Collapse in={visible}>
      <Box sx={{ mb: 2 }}>
        <Paper
          elevation={0}
          sx={{
            p: 2,
            borderRadius: 2,
            backgroundColor: alpha(theme.palette.primary.main, 0.08),
            border: `1px solid ${alpha(theme.palette.primary.main, 0.2)}`,
            display: "flex",
            alignItems: "flex-start",
            gap: 2,
          }}
        >
          <Box
            sx={{
              width: 40,
              height: 40,
              borderRadius: "50%",
              backgroundColor: alpha(theme.palette.primary.main, 0.15),
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              flexShrink: 0,
            }}
          >
            <InfoOutlinedIcon
              sx={{ fontSize: 20, color: theme.palette.primary.main }}
            />
          </Box>

          <Box sx={{ flexGrow: 1, minWidth: 0, alignSelf: "center" }}>
            <Typography
              variant="body2"
              sx={{
                color: "text.primary",
                lineHeight: 1.5,
                fontSize: "0.85rem",
              }}
            >
              <strong>Tip:</strong> Use the{" "}
              <strong>Narrative Only</strong> toggle to focus on General
              Information and the narrative. Click{" "}
              <Box
                component="span"
                sx={{ fontWeight: "bold", color: "success.main" }}
              >
                ON
              </Box>{" "}
              to view <strong>General Information and Narrative</strong>. Click{" "}
              <Box
                component="span"
                sx={{ fontWeight: "bold", color: "error.main" }}
              >
                OFF
              </Box>{" "}
              to view <strong>all sections</strong>.
            </Typography>
          </Box>

          <IconButton
            onClick={onDismiss}
            size="small"
            sx={{
              color: "text.secondary",
              flexShrink: 0,
              mt: -0.5,
              mr: -0.5,
              "&:hover": {
                backgroundColor: alpha(theme.palette.text.primary, 0.08),
              },
            }}
            aria-label="Dismiss tip"
          >
            <CloseIcon fontSize="small" />
          </IconButton>
        </Paper>
      </Box>
    </Collapse>
  );
};
